import { SettingConst } from '@faire/web-api--source/types';

/**
 * Replaced with PRODUCT_TILE_FIRST_ITERATION_250506
 * @deprecated Use PRODUCT_TILE_FIRST_ITERATION_250506 instead
 */
export const PRODUCT_TILE_FIRST_ITERATION_250421 =
  'PRODUCT_TILE_FIRST_ITERATION_250421' as SettingConst<
    'PRODUCT_TILE_FIRST_ITERATION_250421',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
